<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fm_head" id="_idParaDest-1"><a id="_idTextAnchor000"></a><a href="#/text/9780062856616_Contents#r_idParaDest-1"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">Dedication</span></a></h2>
<p class="ded_txt">For Irene,</p>
<p class="ded_txt">who always thinks I’m better than I am.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062856616_Dedication.vue?97d14cd0